// extracted by mini-css-extract-plugin
module.exports = {"mark":"Stats_mark__rDybe","title":"Stats_title__2dMIZ","mainTitle":"Stats_mainTitle__1yZmy","Stats":"Stats_Stats__c3lP-"};